import { connect } from "react-redux";
import { DrawerHandle as Component } from "./DrawerHandle";
import { toggleNotebookCollapse } from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps(state) {
  return {
    collapsed: state.notebook.notebookCollapsed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleCollapse: (val) => {
      dispatch(toggleNotebookCollapse(val));
    },
  };
}

export const DrawerHandle = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
